import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/trafficking/')({
  beforeLoad: () => {
    redirect({ to: '/trafficking/advertiser', throw: true, replace: true });
  },
});
